export enum UserRole {
	Learner = 1,
	Instructor = 2,
	ParentGuardian = 3,
	SchoolOfficial = 4,
	Employee = 5,
	Admin = 6,
	Guest = 7
}
